import { useMutation, useQueryClient } from 'react-query';
import { CreateRegularEmailValues, createEmail } from '../../api';

export function useCreateRegularEmail() {
  const queryClient = useQueryClient();
  return useMutation(
    (variables: CreateRegularEmailValues) => createEmail(variables),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['emails'] });
      },
      onError: err => {
        console.error('Error creating regular email', err);
      },
    },
  );
}
